export default function () {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2306_36796)">
                <path
                    d="M28.875 7.25H7.125C6.29657 7.25 5.625 7.92157 5.625 8.75V24.125H30.375V8.75C30.375 7.92157 29.7034 7.25 28.875 7.25Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M30.4095 29.75H5.59055C4.52935 29.75 3.80372 28.6782 4.19784 27.6929L5.625 24.125H30.375L31.8022 27.6929C32.1963 28.6782 31.4706 29.75 30.4095 29.75Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M16.875 9.5H19.125" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_2306_36796">
                    <rect width="36" height="36" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
